import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { publicContentApi } from "@/lib/api";

/**
 * Homepage Partners strip. Renders ONLY partners the server has cleared for
 * public display (listing on + approval date + active). If none qualify, the
 * whole section is hidden — no heading, no empty state.
 */
export const PartnersSection = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    let alive = true;
    publicContentApi.partners()
      .then((d) => { if (alive) setPartners(d.partners || []); })
      .catch(() => { if (alive) setPartners([]); });
    return () => { alive = false; };
  }, []);

  if (partners.length === 0) return null;

  return (
    <section id="partners" data-testid="landing-partners" className="border-t border-ink bg-white scroll-mt-16">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-24 lg:py-32">
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-ink/75 mb-3">In the ecosystem</div>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-medium leading-[1.0] max-w-2xl">
          Partners building clarity into their platforms.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {partners.map((p) => (
            <a
              key={p.id}
              href={p.entry_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`partner-card-${p.id}`}
              className="group border-2 border-ink bg-paper p-6 flex flex-col hover:bg-ink hover:text-white transition-colors"
            >
              <div className="h-14 flex items-center mb-5">
                {p.logo_url ? (
                  <img src={p.logo_url} alt={`${p.display_name} logo`} className="max-h-14 max-w-[180px] w-auto object-contain" />
                ) : (
                  <span className="font-serif text-2xl tracking-tight">{p.display_name}</span>
                )}
              </div>
              <h3 className="font-serif text-xl tracking-tight">{p.display_name}</h3>
              <p className="font-mono text-sm leading-relaxed mt-2 flex-1 text-ink/80 group-hover:text-white/80">{p.one_line}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-blueprint group-hover:text-white">
                Visit <ArrowUpRight size={13} />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
